<template>
  <div class="wrapper">
    <div class="action menu" @click="toggleVisibility">
      <img :src="icon">
      <div class="menu-items" :class="{visible: headerMenuVisible}">
        <slot></slot>
        <div class="arrow">▲</div>
      </div>
    </div>
  </div>
</template>

<script>

  import Popper from "popper.js";

  export default {

    name: "ActionMenu",

    props: {
      icon: String
    },

    data() {
      return {
        headerMenuVisible: false,
        popper: null
      };
    },

    methods: {
      toggleVisibility(e) {
        this.headerMenuVisible = !this.headerMenuVisible;
        if (this.headerMenuVisible) {
          let anchor = this.$el.querySelector(".action.menu");
          let target = this.$el.querySelector(".menu-items");
          let arrow = this.$el.querySelector(".arrow");
          this.popper = new Popper(anchor, target, {
            placement: "bottom",
            positionFixed: true,
            modifiers: {
              arrow: {
                element: arrow
              },
              flip: {
                behavior: ["bottom"]
              },
            }
          });
          this.popper.scheduleUpdate();
          setTimeout(() => {
            this.popper.scheduleUpdate();
          }, 1);
        } else if (this.popper != null) {
          this.popper.destroy();
        }
        e.stopPropagation();
      }
    }

  };

</script>

<style lang="scss" scoped>
  .wrapper {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .menu {
    cursor: pointer;
    overflow: hidden;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .menu-items {
    display: none;

    &.visible {
      display: flex;
      flex-direction: column;
      margin-top: 15px;
      background-color: white;
      color: #404040;
      border-radius: 5px;
      box-shadow: rgba(0, 0, 0, 0.25) 0px 1px 4px;
      z-index: 4;
    }

    a,
    div:not(.arrow),
    span {
      color: #404040;
      text-decoration: none;
      font-size: 16px;

      &:hover {
        color: var(--primary-color);
      }
    }

    .arrow {
      position: absolute;
      top: -20px;
      font-size: 24px;
      line-height: 1;
      color: white;
      text-shadow: 0 -2px 2px rgba(0, 0, 0, 0.1);
      font-weight: bold;
    }
  }
</style>

<style lang="scss">
  .menu-items .item {
    padding: 10px 20px;

    &:first-child {
      padding-top: 20px;
    }

    &:last-of-type {
      padding-bottom: 20px;
    }
  }
</style>